"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSelected = exports.createQuery = void 0;
const _ = __importStar(require("lodash"));
const createQuery = (params, newPeriod, upcomingPeriod) => {
    const { filters, buildQueryFromList, buildQueryFromCategory } = params;
    let query = [];
    _.each(_.keys(filters), key => {
        const filterCategory = filters[key];
        let result;
        if (buildQueryFromList) {
            result = buildQueryFromList(filterCategory.filters, newPeriod, upcomingPeriod);
        }
        else if (buildQueryFromCategory) {
            result = buildQueryFromCategory(filterCategory, newPeriod, upcomingPeriod);
        }
        else {
            result = [];
        }
        query = [...query, ...result];
    });
    return query;
};
exports.createQuery = createQuery;
const hasSelected = (filters) => {
    let selected = false;
    _.each(_.keys(filters), key => {
        const filterCategory = filters[key] || {};
        selected = selected || _.filter(filterCategory.filters, y => y.isSelected).length > 0;
    });
    return selected;
};
exports.hasSelected = hasSelected;
//# sourceMappingURL=filsters-utils.js.map